export default {
  slices: [
    {
      field: 'ad_type',
      display: 'Ad Type',
      map: {
        'tv_outlined': {
          display: 'TV',
          sortOrder: 1
        },
        'olv': {
          display: 'OLV/Social',
          sortOrder: 2
        }
      }
    },
    {
      field: 'market',
      display: 'Market',
      map: {
        'micro': {
          display: 'Micro/SMB',
          sortOrder: 1
        },
        'mid': {
          display: 'Mid Size',
          sortOrder: 2
        },
        'ent': {
          display: 'Enterprise',
          sortOrder: 3
        },
        'public_sector': {
          display: 'Public Sector',
          sortOrder: 4
        }

      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/TmobileBussiness/config/metadata.js